const SERVICE_LOCATION = {
    BOTH: 2,
    MOBILE: 1,
    ON_PREMISE: 0
};

const LOCATION_SOURCE = {
    CLIENT: 0,
    CONTACT: 1,
    COMPANY: 2
};

const DISCOUNT_STATUS = {
    ACTIVE: 1,
    INACTIVE: 2,
    SUSPENDED: 3
};

const DISCOUNT_TYPE = {
    PERCENTAGE: 0,
    DOLLAR: 1
};

const EXTERNAL_VIEW = {
    SCHEDULE: "schedule",
    TREATMENT: "treatment",
    CENSUS: "census"
};

export default {
    SERVICE_LOCATION,
    DISCOUNT_STATUS,
    DISCOUNT_TYPE,
    EXTERNAL_VIEW
};
